import { Validators } from '@angular/forms';
import { INPUT_TYPES_CONFIG } from '../products.config';

export const HOUSE = {
  nickname: 'PRODUCTS.HOUSE.shortname',
  LIST_OF_OBJECTS: ['houseAdditionalBuildings', 'houseWithContents'],
  properties: [
    {
      name: 'calculatedClientAge', key: 'CLIENT_AGE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.TEL,
      validator: ['', [
        Validators.pattern(/^\d+$/)
      ]]
    },
    {
      name: 'deductible', key: 'DEDUCTIBLE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_HOUSE.5', value: '5000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_HOUSE.75', value: '7500' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_HOUSE.10', value: '10000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_HOUSE.15', value: '15000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_HOUSE.20', value: '20000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_HOUSE.25', value: '25000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_HOUSE.30', value: '30000' },
        ]
      }
    },
    {
      name: 'objectAddress', key: 'OBJECT_ADDRESS', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.STRING,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'objectZipCode', key: 'OBJECT_ZIP_CODE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.TEL,
      validator: ['', [
        Validators.required,
        Validators.pattern('[0-9]{4}$')
      ]]
    },
    {
      name: 'productPackage', key: 'PRODUCT_PACKAGE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.STANDARD', value: 'STANDARD' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.SUPER', value: 'SUPER' }
        ]
      }
    },
    { name: 'houseBuildingType', key: 'BUILDING_TYPE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.HOUSE', value: 'HOUSE' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.TERRACED_HOUSE', value: 'TERRACED_HOUSE' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.DUPLEX', value: 'DUPLEX' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.4_MANS_HOUSE', value: '4_MANS_HOUSE' },
        ]
      }
    },
    {
      name: 'houseBuildingYear', key: 'BUILDING_YEAR', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.DATE,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        dateView: 'multi-years'
      }
    },
    {
      name: 'houseSquareMeters', key: 'SQUARE_METERS', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.NUMBER,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'houseSumInsuredType',
      key: 'SUM_INSURED_TYPE',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      isFirstRiskSumInsuredCheck: true,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SUM_INSURED_TYPE.FULL_VALUE', value: 'FULL_VALUE' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SUM_INSURED_TYPE.FIRST_RISK', value: 'FIRST_RISK' },
        ]
      }
    },
    { name: 'houseFirstRiskSumInsured', key: 'SUM_INSURED', group: 'INSURANCE_INFO' },
    {
      name: 'houseBuildingStandard', key: 'BUILDING_STANDARD', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_STANDARD.NORMAL', value: 'NORMAL' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_STANDARD.BETTER', value: 'BETTER' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_STANDARD.HIGH', value: 'HIGH' },
        ]
      }
    },
    { name: 'houseRotAndAnimalDamage', key: 'HOUSE_ROT_AND_ANIMAL_DAMAGE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'wtcBuildingConstructionFactor', key: 'BUILDING_CONSTRUCTION_FACTOR', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]],
    },
    {
      name: 'buildingUnUsed', key: 'BUILDING_UNUSED_SQM', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_UNUSED_SQM.10', value: '10' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_UNUSED_SQM.20', value: '20' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_UNUSED_SQM.40', value: '40' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_UNUSED_SQM.60', value: '60' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_UNUSED_SQM.NO', value: 'NO' }
        ]
      }
    },
    {
      name: 'houseBuildingMaterials', key: 'BUILDING_MATERIALS', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_MATERIALS.WOOD', value: 'WOOD' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_MATERIALS.CONCRETE', value: 'CONCRETE' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_MATERIALS.MUR_AND_WOOD', value: 'MUR_AND_WOOD' },
        ]
      }
    },
    {
      name: 'houseSMPipeInPipe', key: 'HOUSE_SM_PIPE_IN_PIPE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'houseElectricalSystemRenovationYear', key: 'HOUSE_ELECTRICAL_SYSTEM_RENOVATION_YEAR', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.DATE,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        dateView: 'multi-years'
      }
    },
    {
      name: 'houseDrainagePerformedYear', key: 'HOUSE_DRAINAGE_PERFORMED_YEAR', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.DATE,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        dateView: 'multi-years'
      }
    },
    {
      name: 'houseRoofRenovationYear', key: 'HOUSE_ROOF_RENOVATION_YEAR', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.DATE,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        dateView: 'multi-years'
      }
    },
    { name: 'houseSMFlatRoof', key: 'HOUSE_SM_FLAT_ROOF', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'houseSMAutomaticWaterStop', key: 'HOUSE_SM_AUTOMATIC_WATER_STOP', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'houseNumberOfBathrooms', key: 'HOUSE_NUMBER_OF_BATHROOMS', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_NUMBER_OF_BATHROOMS.UP_TO_3_WET_ROOMS', value: '3-' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_NUMBER_OF_BATHROOMS.4_WET_ROOMS', value: '4' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_NUMBER_OF_BATHROOMS.5_AND_MORE_WET_ROOMS', value: '5+' },
        ]
      }
    },
    { name: 'houseIsRented', key: 'HOUSE_IS_RENTED', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_OWNER_PRIMARY.NOT_RENTED', value: 'NO' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_OWNER_PRIMARY.PARTIALLY_RENTED', value: 'PARTIAL' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_OWNER_PRIMARY.RENTED', value: 'YES' }
        ]
      },
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'houseSMBurglarAlarmConnected', key: 'HOUSE_SM_BURGAR_ALARM_CONNECTED', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SM_BURGAR_ALARM_CONNECTED.LOCAL_NOTIFICATION',
            value: 'LOCAL_NOTIFICATION'
          },
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SM_BURGAR_ALARM_CONNECTED.SECURITY_COMPANY_NOTIFICATION',
            value: 'SECURITY_COMPANY_NOTIFICATION'
          },
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SM_BURGAR_ALARM_CONNECTED.NO',
            value: 'NO'
          }
        ]
      }
    },
    { name: 'houseSMFireAlarmConnected', key: 'HOUSE_SM_FIRE_ALARM_CONNECTED', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'houseSMInterconnectedSmokeDetectors',
      key: 'HOUSE_SM_INTERCONNECTED_SMOKE_DETECTORS',
      group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'wtcHouseownerBasementDry', key: 'HOUSE_OWNER_BASEMENT_DRY', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_OWNER_BASEMENT_DRY.NO_BASEMENT', value: 'NO_BASEMENT' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_OWNER_BASEMENT_DRY.CRAWL_SPACE', value: 'CRAWL_SPACE' },
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_OWNER_BASEMENT_DRY.BASEMENT_NOT_FURNISHED',
            value: 'BASEMENT_NOT_FURNISHED'
          },
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_OWNER_BASEMENT_DRY.BASEMENT_FURNISHED',
            value: 'BASEMENT_FURNISHED'
          },
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_OWNER_BASEMENT_DRY.BASEMENT_PARTIALLY_FURNISHED',
            value: 'BASEMENT_PARTIALLY_FURNISHED'
          }
        ]
      }
    },
    {
      name: 'houseNumberOfResidents', key: 'HOUSE_OWNER_CABIN_RESIDENTS', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_OWNER_CABIN_RESIDENTS.1', value: '1' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_OWNER_CABIN_RESIDENTS.2_TO_5', value: '2-5' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_OWNER_CABIN_RESIDENTS.6_OR_MORE', value: '6+' }
        ]
      }
    },
    {
      name: 'houseWithContents', key: 'HOUSE_WITH_CONTENTS', group: 'INSURANCE_INFO',
      values: [
        { name: 'productSumInsured', key: 'SUM_INSURED', group: 'INSURANCE_INFO',
          inputType: INPUT_TYPES_CONFIG.NUMBER,
          HOUSE_CONTENT_SUM_INSURED_MIN_300000: true,
          validator: ['', [
            Validators.required,
            Validators.pattern(/^(?:3[0-9]{5}|[4-9]\d{5}|\d{7,})$/)
          ]]
        },
        {
          name: 'productPackage', key: 'PRODUCT_PACKAGE', group: 'INSURANCE_INFO',
          inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
          validator: ['', [
            Validators.required
          ]],
          settings: {
            list: [
              { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.STANDARD', value: 'STANDARD' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.SUPER', value: 'SUPER' }
            ]
          }
        },
        {
          name: 'deductible', key: 'DEDUCTIBLE', group: 'INSURANCE_INFO',
          inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
          validator: ['', [
            Validators.required
          ]],
          settings: {
            list: [
              { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_HOUSE.5', value: '5000' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_HOUSE.75', value: '7500' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_HOUSE.10', value: '10000' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_HOUSE.15', value: '15000' }
            ]
          }
        },
      ]
    },
    {
      name: 'houseAdditionalBuildings', key: 'HOUSE_ADDITIONAL_BUILDINGS', group: 'OBJECT_INFO',
      values: [
        {
          name: 'productPackage', key: 'PRODUCT_PACKAGE', group: 'INSURANCE_INFO',
          inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
          validator: ['', [
            Validators.required
          ]],
          settings: {
            list: [
              { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.STANDARD', value: 'STANDARD' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.SUPER', value: 'SUPER' }
            ]
          }
        },
        {
          name: 'houseBuildingHasWater', key: 'HOUSE_BUILDING_HAS_WATER', group: 'OBJECT_INFO',
          inputType: INPUT_TYPES_CONFIG.BOOLEAN,
          validator: ['', [
            Validators.required
          ]]
        },
        {
          name: 'houseBuildingYear', key: 'BUILDING_YEAR', group: 'OBJECT_INFO',
          inputType: INPUT_TYPES_CONFIG.DATE,
          validator: ['', [
            Validators.required
          ]],
          settings: {
            dateView: 'multi-years'
          }
        },
        {
          name: 'houseBuildingStandard', key: 'BUILDING_STANDARD', group: 'OBJECT_INFO',
          inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
          validator: ['', [
            Validators.required
          ]],
          settings: {
            list: [
              { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_STANDARD.NORMAL', value: 'NORMAL' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_STANDARD.BETTER', value: 'BETTER' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_STANDARD.HIGH', value: 'HIGH' },
            ]
          }
        },
        {
          name: 'houseSumInsuredType',
          key: 'SUM_INSURED_TYPE',
          inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
          isFirstRiskSumInsuredCheck: true,
          validator: ['', [
            Validators.required
          ]],
          settings: {
            list: [
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SUM_INSURED_TYPE.FULL_VALUE', value: 'FULL_VALUE' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SUM_INSURED_TYPE.FIRST_RISK', value: 'FIRST_RISK' },
            ]
          }
        },
        { name: 'houseFirstRiskSumInsured', key: 'SUM_INSURED', group: 'INSURANCE_INFO' },
        {
          name: 'houseSquareMeters', key: 'SQUARE_METERS', group: 'OBJECT_INFO',
          inputType: INPUT_TYPES_CONFIG.NUMBER,
          validator: ['', [
            Validators.required
          ]]
        },
        {
          name: 'houseBuildingMaterials', key: 'BUILDING_MATERIALS', group: 'OBJECT_INFO',
          inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
          validator: ['', [
            Validators.required
          ]],
          settings: {
            list: [
              { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_MATERIALS.WOOD', value: 'WOOD' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_MATERIALS.CONCRETE', value: 'CONCRETE' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_MATERIALS.MUR_AND_WOOD', value: 'MUR_AND_WOOD' },
            ]
          }
        },
        { name: 'houseBuildingType', key: 'BUILDING_TYPE', group: 'OBJECT_INFO',
          inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
          validator: ['', [
            Validators.required
          ]],
          settings: {
            list: [
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.CARPORT', value: 'CARPORT' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.GARAGE_NOT_ISOLATED', value: 'GARAGE_NOT_ISOLATED' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.GARAGE_ISOLATED', value: 'GARAGE_ISOLATED' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.ROW_GARAGE', value: 'ROW_GARAGE' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.LOGCABIN_NOT_ISOLATED', value: 'LOGCABIN_NOT_ISOLATED' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.LOGCABIN_MACHINE', value: 'LOGCABIN_MACHINE' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.LOGCABIN_BY_HAND', value: 'LOGCABIN_BY_HAND' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.SHED_NOT_ISOLATED', value: 'SHED_NOT_ISOLATED' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.SHED_ISOLATED', value: 'SHED_ISOLATED' },
            ]
          }
        },
      ]
    },
  ],
  icon: 'house'
};
